<template>
	<div class="item-list-container">
		<p class="title">Besvarade frågor</p>

		<div
			class="list-container"
			v-for="checklist in comChecklists"
			:key="checklist.id"
		>
			<div class="title">{{ `${checklist.name}` }}</div>
			<div
				class="category-container"
				v-for="(question, index) in checklist.questions"
				:key="index"
			>
				<p
					class="category"
					:class="{ 'is-first': index === 0 }"
					v-if="
						question.groupName !==
							checklist.questions[index > 0 ? index - 1 : index].groupName ||
							index === 0
					"
				>
					{{ question.groupName }}
				</p>
				<div class="question-container">
					<div class="question-description" :class="{ mobile: isMobile }">
						<p>{{ question.name || question.description }}</p>
						<p class="question-flaw">
							{{
								question.answerDescription
									? `Brist: ${question.answerDescription}`
									: ""
							}}
						</p>
					</div>

					<div class="question-buttons" :class="{ mobile: isMobile }">
						<button
							v-if="question.answer === question.positive"
							class="button is-success active"
						>
							{{ question.positive }}
						</button>
						<button
							v-if="question.answer === question.negative"
							class="button is-danger active"
						>
							{{ question.negative }}
						</button>
						<button v-if="question.answer === ''" class="button is-link">
							Ej relevant
						</button>
					</div>
				</div>
			</div>
		</div>
		<div class="panel-list no-hover" v-if="comChecklists.length == 0">
			<p class="panel-list-item">Inga besvarade</p>
		</div>
	</div>
</template>

<script>
import iconMixin from '@/mixins/iconMixin.js';
import { mapGetters } from 'vuex';

export default {
	mixins: [iconMixin],
	props: {
		checklists: Array
	},
	computed: {
		...mapGetters('appStore', ['isMobile']),
		comChecklists() {
			let list = [];
			this.checklists.forEach(checklist => {
				let questionList = [];
				checklist.roundHistoryQuestions.forEach(question => {
					if (question.answer !== null) {
						questionList.push(question);
					}
				});

				if (questionList.length) {
					list.sort((a, b) =>
						a.groupName > b.groupName
							? 1
							: a.groupName === b.groupName
								? a.id > b.id
									? 1
									: -1
								: -1
					);
					checklist.questions = questionList;
					list.push(checklist);
				}
			});

			return list;
		}
	}
};
</script>

<style lang="scss" scoped>
.item-list-container {
  margin-top: 1rem;
  p.title {
    font-size: 1.5rem;
  }
}
.list-container {
  &:not(:first-child) {
    margin-top: 0.8rem;
  }
  .title {
    font-size: 1.3rem;
    margin-bottom: 0.8rem;
  }
}
p.category {
  border-top: 1px solid #d3d3d35d;
  &.is-first {
    border: none;
  }
  font-weight: 600;
}
.category-container {
  border-bottom: 1px solid #d3d3d35d;
  &:last-child {
    border: none;
  }
}
.question-container {
  padding: 0.75rem;
  display: flex;
  flex-wrap: wrap;
  .question-info {
    margin-left: auto;
  }
  .question-description,
  .question-info {
    max-width: 50%;
    min-width: 50%;
    margin-bottom: 0.5rem;
    &.mobile {
      padding: 10px 0;
      min-width: 100%;
      max-width: 100%;
    }
    a {
      color: #4a87d8;
    }
  }
  .question-description {
    p {
      font-weight: 500;
    }
  }
  .question-info {
    font-size: 15px;
  }
  .question-buttons {
    print-color-adjust: exact;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    &.mobile {
      justify-content: space-between;
    }
    .button {
      min-width: 80px;
      margin: 0 0.25rem;
      &.is-success {
        background-color: #02aa3d;
      }
      &:not(.active) {
        &.is-success {
          background-color: #7eca99;
        }
        &.is-danger {
          background-color: #e98787;
        }
      }
      &:first-child {
        margin-left: 0;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
}
.question-flaw {
  // margin-top: 0.6rem;
  position: absolute;
}

@media print {
  .panel-list {
    padding: 0;
  }
  .item-list-container{
    break-inside: avoid;
  }

  .question-container:not(:first-of-type) {
    break-inside: avoid;
  }
}
</style>
